import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router-dom';
import { AuthProvider } from '@avayler/saas-nextjs-auth-cognito-client';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Dropdown,
  Flex,
  type MenuProps,
  Skeleton,
  Space,
  theme,
} from 'antd';
import { clientConfig } from 'pos-client/clientConfig.ts';
import { Breadcrumbs } from 'pos-client/components/generic/breadcrumb/Breadcrumb.tsx';
import { useNavMenuContext } from 'pos-client/contexts/NavMenuContext.tsx';
import { useCurrentUser } from 'pos-client/hooks/useCurrentUser.ts';

interface AppToolbarProps {
  isMobile?: boolean;
  loading?: boolean;
}

export const AppToolbar = forwardRef<HTMLElement, AppToolbarProps>(
  ({ isMobile, loading = false }, ref) => {
    const { t } = useTranslation();
    const { token } = theme.useToken();
    const { menuCollapsed, setMenuCollapsed } = useNavMenuContext();

    /* Dark Mode theme control const { themeColorScheme, changeThemeColorScheme } = useTheme(); */
    const matches = useMatches();

    const userLogout = () => {
      sessionStorage.removeItem('surveySearchFormFilters');
      AuthProvider.signOut(clientConfig.bffBaseUrl);
    };
    const { currentUser } = useCurrentUser();

    const items: MenuProps['items'] = [
      {
        key: '1',
        icon: <FontAwesomeIcon icon={faUser} />,
        onClick: userLogout,
        danger: true,
        label: t('common.buttons.logout'),
      },
    ];

    return (
      <>
        <Flex
          justify="space-between"
          align="center"
          style={{
            paddingLeft: token.paddingSM,
            paddingRight: token.paddingSM,
            paddingTop: token.paddingXS,
            paddingBottom: token.paddingXS,
            backgroundColor: token.Layout?.headerBg,
          }}
          ref={ref}
        >
          <Space size="small">
            <Button
              hidden={!isMobile}
              icon={<FontAwesomeIcon icon={menuCollapsed ? faBars : faXmark} />}
              type="text"
              onClick={() => setMenuCollapsed((current) => !current)}
              loading={loading}
            />
            <Flex hidden={matches.length < 1}>
              <Breadcrumbs loading={loading} />
            </Flex>
          </Space>

          <Space size="small">
            {/* Dark Mode Toggle - Will be implemented in seperate ticket    
          <Segmented
            size="small"
            shape="round"
            options={[
              { value: 'light', icon: <FontAwesomeIcon icon={faSunBright} /> },
              { value: 'dark', icon: <FontAwesomeIcon icon={faMoon} /> },
            ]}
            value={themeColorScheme}
            onChange={changeThemeColorScheme}
          />*/}
            {loading ? (
              <Skeleton.Button active size="small" />
            ) : (
              <Dropdown menu={{ items }} placement="bottom">
                <Button type="text" icon={<FontAwesomeIcon icon={faUser} />}>
                  {currentUser?.fullName ?? '-'}
                </Button>
              </Dropdown>
            )}
          </Space>
        </Flex>
      </>
    );
  }
);
